import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { SimpleTable } from '../SimpleTable';
import { getFlattenColumns } from '../../../utils';
const generateData = (rowsConfig, data) => {
    return rowsConfig.map((row, idx) => {
        // if grouped row
        if ('items' in row) {
            return {
                name: row.name,
                items: generateData(row.items, data)
            };
        }
        const rowData = row.propertyName ? data[row.propertyName] : {};
        return {
            key: idx,
            value: { ...rowData, rowName: row.name }
        };
    });
};
const generateTransposeData = (rowsConfig, columnsConfig, data) => {
    const flatternRows = getFlattenColumns(rowsConfig);
    return columnsConfig.map((column, idx) => {
        // if grouped column
        if ('items' in column) {
            return {
                name: column.name,
                items: generateTransposeData(flatternRows, column.items, data)
            };
        }
        const columnProperty = column.propertyName;
        if (!columnProperty) {
            return { key: idx, value: {} };
        }
        const rowValue = flatternRows.reduce((acc, cur) => {
            if (!cur.propertyName) {
                return acc;
            }
            acc[cur.propertyName] = data[cur.propertyName][columnProperty] ?? '';
            return acc;
        }, {});
        rowValue.rowName = column.name;
        return { key: idx, value: rowValue };
    });
};
const TransposableTableFC = ({ noBg, noItemsTitle, columnsConfig, rowsConfig, data, transpose, tableSx }) => {
    const tableData = useMemo(() => {
        if (transpose) {
            return generateTransposeData(rowsConfig, columnsConfig, data);
        }
        return generateData(rowsConfig, data);
    }, [columnsConfig, data, rowsConfig, transpose]);
    const tableColumns = useMemo(() => {
        const columns = transpose ? rowsConfig : columnsConfig;
        return [
            {
                name: '',
                propertyName: 'rowName',
                sticky: true
            },
            ...columns
        ];
    }, [columnsConfig, rowsConfig, transpose]);
    return (_jsx(SimpleTable, { columns: tableColumns, rows: tableData, noBg: noBg, noItemsTitle: noItemsTitle, tableSx: tableSx }));
};
export const TransposableTable = memo(TransposableTableFC);
//# sourceMappingURL=TransposableTable.js.map